import React, { useEffect, useReducer, useState } from "react";
import { NavigationContainer } from "@react-navigation/native";
import { createStackNavigator } from "@react-navigation/stack";
import LoginScreen from "./Login";
import ChangePasswordScreen from "./ChangePassword";
import Dashboard from "./Dashboard";
import refs from "../Service/Navigate";
import "../app.css";
import AutoSubmitForm from "./AutoSubmitForm";
import { log } from "react-native-reanimated";

const Stack = createStackNavigator();
const AppStack = createStackNavigator();

export default function AppContainer() {
  const [, forceUpdate] = useReducer((a) => a + 1, 0);
  const token = localStorage.getItem("token");
  const [submit, setSubmit] = useState(false);
  const [returnUrl, setReturnUrl] = useState("/LoginViaRequest.aspx");

  return (
    <>
      <NavigationContainer
        linking={{
          config: {
            screens: {
              App: {
                path: "App",
                screens: {
                  logOut: {
                    path: "",
                  },
                  LoginScreen: {
                    path: "Login",
                  },
                  Dashboard: {
                    path: "Dashboard",
                  },
                },
              },
            },
          },
        }}
        ref={(n) => (refs.navigation = n)}
      >
        <AppStack.Navigator headerMode="none">
          <AppStack.Screen name="App">
            {() => (
              <Stack.Navigator headerMode="none">
                {token ? (
                  <>
                    <Stack.Screen
                      options={{ title: "داشبورد", headerShown: false }}
                      name="Dashboard"
                      key="Dashboard"
                      component={Dashboard}
                      initialParams={{ Stack: Stack }}
                    />
                    <Stack.Screen
                      options={{ title: "داشبورد", headerShown: false }}
                      name="ChangePasswordScreen"
                      key="ChangePasswordScreen"
                      component={ChangePasswordScreen}
                      initialParams={{ Stack: Stack }}
                    />
                    <Stack.Screen
                      options={{ title: "logout", headerShown: false }}
                      name="logOut"
                      key="logOut"
                    >
                      {({ route: { params }, navigation }) => {
                        console.log(params);

                        useEffect(() => {
                          if (params?.ReturnUrl) {
                            localStorage.removeItem("token");
                            window.location.href = "/App";
                          } else {
                            navigation.replace("Dashboard");
                          }
                        }, [params?.ReturnUrl]);

                        return null;
                      }}
                    </Stack.Screen>
                  </>
                ) : (
                    <>
                      <Stack.Screen
                        options={{ title: "ورود" }}
                        name="LoginScreen"
                        key="LoginScreen"
                        component={LoginScreen}
                      />

                      <Stack.Screen
                        options={{ title: "داشبورد", headerShown: false }}
                        name="ChangePasswordScreen"
                        key="ChangePasswordScreen"
                        component={ChangePasswordScreen}
                        initialParams={{ Stack: Stack }}
                      />

                      <Stack.Screen
                        options={{ title: "logout", headerShown: false }}
                        name="logOut"
                        key="annoylogOut"
                      >
                        {({ route: { params }, navigation }) => {
                          console.log(params);
                          useEffect(() => {
                            navigation.navigate("LoginScreen");
                          }, []);

                          return null;
                        }}
                      </Stack.Screen>
                    </>
                  )}
              </Stack.Navigator>
            )}
          </AppStack.Screen>
        </AppStack.Navigator>
      </NavigationContainer>

      <AutoSubmitForm
        actionUrl={returnUrl}
        params={{ token: token }}
        autoSubmit={submit}
      />
    </>
  );
}
